module.exports = __webpack_public_path__ + "img/matr1x_fire_banner_subscription_gift.7d67c439.png";